var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiplayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4855_27646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 250,
    height: 160,
    rx: 8,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4855_27646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.047,
    y: 20,
    width: 71.8995,
    height: 95.866,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4855_27646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.047,
    y: 20,
    width: 71.8995,
    height: 95.866,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.047,
    y: 21,
    width: 69.8995,
    height: 93.866,
    rx: 3,
    stroke: "#2990FB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 130.039,
    y: 29.5879,
    width: 59.9162,
    height: 40.743,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.812,
    y: 58.3477,
    width: 20.3715,
    height: 7.18995,
    rx: 3.59497,
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.586,
    y: 89.5039,
    width: 20.3715,
    height: 7.18995,
    rx: 3.59497,
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.039,
    y: 75.1211,
    width: 59.9162,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.039,
    y: 81.1152,
    width: 59.9162,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4855_27646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 36.7773,
    width: 71.8995,
    height: 95.866,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37.7773,
    width: 69.8995,
    height: 93.866,
    rx: 3,
    stroke: "#D8D8D8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.9922,
    y: 89.5039,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5703,
    y: 89.5039,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1484,
    y: 89.5039,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7266,
    y: 89.5039,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7656,
    y: 107.48,
    width: 20.3715,
    height: 7.18995,
    rx: 3.59497,
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9961,
    y: 58.3477,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5742,
    y: 58.3477,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1484,
    y: 58.3477,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7227,
    y: 58.3477,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9961,
    y: 73.9238,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5742,
    y: 73.9238,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1484,
    y: 73.9238,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7227,
    y: 73.9238,
    width: 13.1816,
    height: 13.1816,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9961,
    y: 43.9668,
    width: 59.9162,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9961,
    y: 49.959,
    width: 59.9162,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4855_27646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.102,
    y: 36.7773,
    width: 71.8995,
    height: 95.866,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.102,
    y: 37.7773,
    width: 69.8995,
    height: 93.866,
    rx: 3,
    stroke: "#D8D8D8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 239.094,
    y: 43.9668,
    width: 59.9162,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.094,
    y: 49.959,
    width: 59.9162,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.094,
    y: 55.9492,
    width: 40.1439,
    height: 3.59497,
    rx: 1.79749,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.403 73.8948L122.023 73.5689L122.403 73.8948ZM87.404 80.4195C87.133 80.4725 86.9563 80.7352 87.0093 81.0062L87.8736 85.4224C87.9266 85.6934 88.1893 85.8701 88.4603 85.8171C88.7313 85.764 88.908 85.5014 88.8549 85.2304L88.0867 81.3048L92.0123 80.5366C92.2833 80.4836 92.46 80.2209 92.4069 79.9499C92.3539 79.6789 92.0912 79.5022 91.8202 79.5552L87.404 80.4195ZM151.011 61.4414C146.533 61.4415 141.835 61.4864 136.984 63.0308C132.119 64.5796 127.132 67.6244 122.023 73.5689L122.782 74.2207C127.782 68.4026 132.616 65.4708 137.288 63.9837C141.973 62.492 146.526 62.4415 151.011 62.4414L151.011 61.4414ZM122.023 73.5689C109.762 87.8369 94.6631 85.126 87.7791 80.4953L87.2209 81.325C94.4505 86.1881 110.134 88.938 122.782 74.2207L122.023 73.5689Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.039 107.88L225.419 107.556L225.039 107.88ZM267.938 116.066C268.209 116.118 268.387 116.38 268.335 116.651L267.488 121.071C267.436 121.342 267.174 121.52 266.903 121.468C266.632 121.416 266.454 121.154 266.506 120.883L267.259 116.954L263.33 116.201C263.059 116.149 262.881 115.887 262.933 115.616C262.985 115.345 263.247 115.167 263.518 115.219L267.938 116.066ZM189.953 92.5957C195.446 92.5959 201.191 92.652 207.122 94.5563C213.067 96.4651 219.167 100.218 225.419 107.556L224.658 108.204C218.514 100.994 212.567 97.3546 206.817 95.5084C201.052 93.6577 195.453 93.5959 189.953 93.5957L189.953 92.5957ZM225.419 107.556C240.501 125.255 259.082 121.896 267.563 116.143L268.124 116.971C259.296 122.96 240.125 126.356 224.658 108.204L225.419 107.556Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.086,
    y: 65.5371,
    width: 59.9162,
    height: 40.743,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.543,
    y1: 65.5371,
    x2: 269.543,
    y2: 106.28,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.345,
    cy: 85.609,
    r: 4.49372,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.645 85.61L268.442 83.7938L268.442 87.4261L266.645 85.61Z",
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.039 85.61L270.242 83.7938L270.242 87.4261L272.039 85.61Z",
    fill: "#F2F3F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4855_27646",
    x: 112.047,
    y: 10,
    width: 95.8984,
    height: 119.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4855_27646",
    x: 104.047,
    y: 4,
    width: 111.898,
    height: 135.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4855_27646",
    x: -5,
    y: 20.7773,
    width: 111.898,
    height: 135.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4855_27646",
    x: 213.102,
    y: 20.7773,
    width: 111.898,
    height: 135.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4855_27646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplayer);
export default __webpack_public_path__ + "static/media/multiplayer.c11caa1cdc13e45e052d04666d9fbb0d.svg";
export { ForwardRef as ReactComponent };